import { SevenDaysInMilliseconds } from "./DateConstants";
/**
 * news id for news bar
 */ export const NewsBarNewsIds = {
    OcdiRedirectExperience: "OCDI_REDIRECT_EXPERIENCE",
    BrowserUpgrade: "BROWSER_UPGRADE"
};
/**
 * Map for news dismiss time saved in local storage
 */ export const NewsDismissUntilMap = {
    [NewsBarNewsIds.OcdiRedirectExperience]: {
        key: "uwredu",
        dismissTime: SevenDaysInMilliseconds
    },
    [NewsBarNewsIds.BrowserUpgrade]: {
        key: "budu",
        dismissTime: SevenDaysInMilliseconds
    }
};
